

































































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PaginationModel, VHeaders } from '@/models/pagedlistmodel';
import { DateTimeHelper as _dateTime } from '@/helper/date-time.helper';
import { Base } from '@/components/common/base';
import { userService, messageService, templateService } from '@/shared';
import { ConversationTypes, MetadataType, TemplateAssociationType } from '@/enums/enums';
import { IDialogOption } from '@/models/dialog';
import { Template } from '@/models/template';
import { MessageCreateViewModel } from '@/models/telephony/message';
import { VFields } from '@/models/v-fields';
import { PreCsiFollowUpResponse } from '@/Alynk.dtos';
import { NotificationType } from '@/helper/enum';

@Component({
    props: ['methodName', 'progress'],
    computed: {
        methodtoCall: {
            get() {
                return this.$props.methodName;
            },
        },
    },

    components: {
        Grid: () => import('@/components/common/app.grid.vue'),
        AppPagination: () => import('@/components/common/app.pagination.vue'),
        AppDialog: () => import('@/components/common/app.dialog.vue'),
    },

})
 class PreCsiFollowUpListPage extends Base {

    public allAdvisors: any[] = [];
    public selectedAdvisorId: string = "";
    public selectedRecord: PreCsiFollowUpResponse;
    public followupStatus: string = "";
    public headers: VHeaders[] = [
        {
            text: 'Repair Order#',
            align: 'left',
            value: 'repairOrderNumber',
            sortable: true,
        },
        {
            text: 'Customer Name',
            align: 'left',
            value: 'customerName',
            sortable: false,

        },
        {
            text: 'Close Date',
            align: 'left',
            value: 'closeDate',
            sortable: false,
        },
        {
            text: 'Service Advisor',
            align: 'left',
            value: 'serviceAdvisorName',
            sortable: false,
        },
        {
            text: "Status",
            align: "left",
            value: "isFollowUpSend",
            sortable: false,
            fieldType: "template",
            template: (item) => {
                if (
                    item.latestSentiment.toLowerCase()  == "positive" 

                ) {
                    return `<div style="display: block;text-align: left;"><span style="background-color: green;color:white; font-size: 12px; display: block; text-align: center; width: fit-content;padding-left: 10px;padding-right: 10px; padding-top: 3px; padding-bottom: 3px; border-radius: 50px;min-width:64px;">Not Required</span></div>`;

                }else if (
                    item.isFollowUpSend == true && item.isSecondaryTextSent == false && item.latestSentiment.toLowerCase()  != "positive"

                ) {
                    return `<div style="display: block;text-align: left;"><span style="background-color: lightgreen;color:black; font-size: 12px; display: block; text-align: center; width: fit-content;padding-left: 10px;padding-right: 10px; padding-top: 3px; padding-bottom: 3px; border-radius: 50px;min-width:64px;">Sent</span></div>`;

                } else if (item.isFollowUpSend == false && item.isSecondaryTextSent == false && item.latestSentiment.toLowerCase()  != "positive") {
                    return `<div style="display: block;text-align: left;"><span style="background-color: lightgray;color:black; font-size: 12px; display: block; text-align: center; width: fit-content;padding-left: 10px;padding-right: 10px; padding-top: 3px; padding-bottom: 3px; border-radius: 50px;min-width:64px;">Pending</span></div>`;
                }
                else if (item.isFollowUpSend == true && item.isSecondaryTextSent == true && item.latestSentiment.toLowerCase()  != "positive") {
                    return `<div style="display: block;text-align: left;"><span style="background-color: yellow;color:black; font-size: 12px; display: block; text-align: center; width: fit-content;padding-left: 10px;padding-right: 10px; padding-top: 3px; padding-bottom: 3px; border-radius: 50px;min-width:64px;">Reminder Sent</span></div>`;
                }

            }
        },
        {
            text: "Sentiment",
            align: "left",
            value: "sentiment",
            sortable: false,
            fieldType: "template",
            template: (item) => {
                if (
                    item.sentiment == "positive" ||
                    item.sentiment == "Positive"
                ) {
                    return `<span style="color: green;font-size: 27px;
    margin-left: 15px; ">
                  <i
                    class="fa fa-smile-o customer-sentiment-smile-font"
                    aria-hidden="true"
                  ></i>
                </span>`;
                } else if (
                    item.sentiment == "negative" ||
                    item.sentiment == "Negative"
                ) {
                    return ` <span style="color: red;font-size: 27px;
    margin-left: 15px;">
                  <i
                    class="fa fa-frown-o customer-sentiment-smile-font"
                    aria-hidden="true"
                  ></i>
                </span>`;
                } else if (
                    item.sentiment == "neutral" ||
                    item.sentiment == "Neutral"
                ) {
                    return ` <span style="color: grey;font-size: 27px;
    margin-left: 15px;">
                  <i
                    class="fa fa-meh-o customer-sentiment-smile-font"
                    aria-hidden="true"
                  ></i>
                </span>`;
                }

                else if (item.sentiment && item.sentiment.length > 1) {
                    var sentiments = this.filterUniqueWithLimit(item.sentiment);
                    var iconHtml = `<div>`;
                    var sentiments = sentiments.filter(value => typeof value === 'string' && value.trim() !== '');
                    sentiments = sentiments.reverse();//order by asc
                    for (let index = 0; index < sentiments.length; index++) {
                        const element = sentiments[index] as string;

                        if (element.toLowerCase() == "positive") {
                            iconHtml += `<span style="color: green;font-size: 27px;">
                          <i class="fa fa-smile-o customer-sentiment-smile-font"></i>
                        </span>`;
                        }
                        else if (element.toLowerCase() == "neutral") {
                            iconHtml += ` <span style="color: grey;font-size: 27px; margin-left: -2px;">
                        <i class="fa fa-meh-o customer-sentiment-smile-font"></i>
                        </span>`;
                        }
                        else if (element.toLowerCase() == "negative") {
                            iconHtml += ` <span style="color: red;font-size: 27px; margin-left: -2px;">
                        <i class="fa fa-frown-o customer-sentiment-smile-font"></i>
                        </span>`;
                        }

                    }
                    return iconHtml += `</div>`;
                }
            },
        },
        {
            text: 'Follow-Up Status',
            align: 'center',
            value: 'followupStatus',
            sortable: false,
            fieldType: "templateSelect",
            onChange: (item): void => {
                this.setFollowUpStatus(item);
            },
            template: (item) => { 
                // Determine the default selected value based on the item.followup value
                let defaultValue = "incomplete"; // default to "Incomplete"
                if (item.followupStatus === "inprogress") {
                    defaultValue = "inprogress"; // "Inprogress"
                } else if (item.followupStatus === "completed") {
                    defaultValue = "completed"; // "Completed"
                }
    
                return `<span style="display: flex; justify-content: center;">
                    <select name="followUpStatus" id="${item.customerKey}_followUpStatus" class="custom-select">
                        <option value="incomplete" ${defaultValue === "incomplete" ? "selected" : ""}>Incomplete</option>
                        <option value="inprogress" ${defaultValue === "inprogress" ? "selected" : ""}>Inprogress</option>
                        <option value="completed" ${defaultValue === "completed" ? "selected" : ""}>Completed</option>
                    </select>
                    <span><i class="fa fa-chevron-down" style="color: #212121; margin-left: -25px; margin-top: 9px;"></i></span>
                </span>`;
            }
        },
        {
            align: 'center',
            isNotDataProp: true,
            sortable: false,
            text: 'Action',
        },

    ];


    public followUpNoteHeaders: VHeaders[] = [
        {
            align: "left",
            text: "Followup Note",
            value: "followupNote",
        },
        {
            align: "left",
            text: "Date",
            value: "noteDateTime",
            fieldType: "date",
        },
        {
            align: "left",
            text: "Submitted By",
            value: "noteSubmittedBy",
        }
    ];



    public conversationHeaders: VHeaders[] = [
        {
            align: "left",
            text: this.$parent.$t("sendMessage.rOSendMessageGrid.date") as string,
            value: "createdAt",
            fieldType: "date",
        },
        {
            align: "left",
            text: this.$parent.$t("sendMessage.rOSendMessageGrid.from") as string,
            value: "messageJson.from",
        },
        {
            align: "left",
            text: this.$parent.$parent.$t(
                "sendMessage.rOSendMessageGrid.to"
            ) as string,
            value: "messageJson.to",
        },
        {
            align: "left",
            text: this.$parent.$parent.$t(
                "sendMessage.rOSendMessageGrid.message"
            ) as string,
            value: "messageJson.textJson.body",
        },
        {
            text: "Sentiment",
            align: "left",
            value: "messageJson.customerSentiment",
            sortable: false,
            fieldType: "template",
            template: (item) => {
                if (
                    item.customerSentiment == "positive" ||
                    item.customerSentiment == "Positive"
                ) {
                    return `<span style="color: green">
                  <i
                    class="fa fa-smile-o customer-sentiment-smile-font"
                    aria-hidden="true"
                  ></i>
                </span>`;
                } else if (
                    item.customerSentiment == "negative" ||
                    item.customerSentiment == "Negative"
                ) {
                    return ` <span style="color: red">
                  <i
                    class="fa fa-frown-o customer-sentiment-smile-font"
                    aria-hidden="true"
                  ></i>
                </span>`;
                } else if (
                    item.customerSentiment == "neutral" ||
                    item.customerSentiment == "Neutral"
                ) {
                    return ` <span style="color: grey">
                  <i
                    class="fa fa-meh-o customer-sentiment-smile-font"
                    aria-hidden="true"
                  ></i>
                </span>`;
                }
            },
        },
    ];

    public filterUniqueWithLimit(arr, maxCount = 2) {
        const itemCounts = {}; // Keep track of occurrences of each item
        return arr.filter(item => {
            // Use JSON.stringify to handle objects, but keep it simple for other types
            const key = typeof item === 'object' ? JSON.stringify(item) : item;

            // Initialize or increment the count for each unique item
            itemCounts[key] = (itemCounts[key] || 0) + 1;

            // Only include the item if it hasn't exceeded maxCount
            return itemCounts[key] <= maxCount;
        });
    }

    public followUpPagination = new PaginationModel('repairOrderNumber', true);
    public followupRecords: any[] = [];
    public menu: boolean = false;
    public followupDate: string = _dateTime.currentDate(new Date());
    public loading: boolean = false;
    public conversationLoading: boolean = false;
    public followUpNoteLoading: boolean = false;
    public percentageLoading: boolean = false;
    public actions: any[] = [];
    public tenantId: number;
    public enterpriseId: number;
    public storeId: number;
    public pagedTextLog: any[] = [];
    public followUpNoteItems: any[] = [];
    public pagination = new PaginationModel("name");
    public followUpNotePagination = new PaginationModel("followupNote");
    public customerKey = "";
    public recordKey = "0";
    public recordIdentifier = "";
    public templates: Template[] = [];
    public roNumber: "";
    public customerPhone: string = "";
    public disableSubmitButton: boolean = false;
    public form: any = {};
    public formFields: Array<VFields<any>> = [];
    public messageToSend: MessageCreateViewModel = new MessageCreateViewModel(
        ConversationTypes[ConversationTypes.Text]
    );

    public setFields(): void {
        this.formFields = [
            {
                key: 'template',
                type: 'v-alynk-select',
                required: false,
                templateOptions: {
                    label: "Template",
                    required: false,
                    disabled: false,
                    time: true,
                    value: 'id',
                    text: 'name',
                    items: this.templates,
                    altag: 'Template',
                    events: {
                        onChange: async (items: Template[], value) => {
                            try {
                                this.formlyShowSkeleton(this.formFields, 'body');
                                const response = await templateService.getTemplateDescription(
                                    value,
                                    '',
                                    '',
                                    '',
                                    '',
                                    this.roNumber,
                                    '',
                                    this.customerKey,
                                    this.recordKey
                                );
                                this.messageToSend.body = response.text;
                            } finally {
                                this.formlyHideSkeleton(this.formFields, 'body');
                            }
                        },
                    },
                    loading: false,
                },
            },
            {
                key: 'body',
                type: 'v-alynk-textarea',
                required: true,
                templateOptions: {
                    label: "Body",
                    validations: 'required',
                    required: true,
                    disabled: false,
                    multiple: false,
                    loading: false,
                },
            }
        ];
    }
    public followUpNote = "";
    public followUpNoteRepairOrderNumber = "";

    public conversationPopup: IDialogOption = {
        width: 1400,
        title: 'Conversation Detail',
        model: false,
        loading: false,
        onClose: (): void => {
            this.customerKey = "";
            this.roNumber = "";
            this.customerPhone = "";
            this.messageToSend.body = "";
            this.messageToSend.template = "";
            this.conversationPopup.model = false;
            this.getTemplates();
        },
    };

    public followUpStatusPopup: IDialogOption = {
        width: 800,
        title: 'Follow-Up Status Note',
        model: false,
        action: {
            color: 'success',
            icon: 'fas fa-paper-plane',
            text: 'Send',
            disable: false,
        },
        loading: false,
        onAction: (): void => {
            this.sendNote();
        },
        onClose: (): void => {
            this.$validator.reset();
        }
    };

    public followUpNotePopup: IDialogOption = {
        width: 800,
        title: 'Follow-Up Note Detail',
        model: false,
        loading: false,
        onClose: (): void => {
            this.followUpNotePopup.model = false;
        },
    };

    public sentimentTypesItem: any[] = [
        {
            text: "Please select value",
            value: ""
        },
        {
            text: "Negative",
            value: "Negative"
        },
        {
            text: "Neutral",
            value: "Neutral"
        },
        {
            text: "Positive",
            value: "Positive"
        },
    ];

    public sentimentType = "";
    public negativeCountPercentage = "0";
    public neutralCountPercentage = "0";
    public positiveCountPercentage = "0";
    public noRespondentCountPercentage = "0";
    public TotalCountPercentage = 0;

    public mounted() {
        // activating tab
        this.$root.$emit('sidebar.layout.vue', 'followupDashboard');
        this.getFollowUpRecords();
        this.preCsiFollowSentimentCount();
        this.getAllAdvisors();
        this.setActions();
        this.setFields();
        this.getTemplates();
    }

    public setFollowUpStatus(item) {
        this.followUpStatusPopup.model = true;
        this.selectedRecord = item;
        const elementId = `${item.customerKey}_followUpStatus`;  // Construct the element ID
            const selectElement = document.getElementById(elementId) as HTMLSelectElement;  // Get the select element
            if (selectElement) {
                const currentStatus = selectElement.value;  // Get the selected value
                this.followupStatus =  currentStatus.charAt(0).toUpperCase() + currentStatus.slice(1).toLowerCase();
            }
    }

    public created(): void {
        this.tenantId = this.userSession.tenantId;
        this.enterpriseId = this.userSession.enterpriseId;
        this.storeId = this.userSession.storeId;
    }

    public setActions() {
        this.actions = [
            {
                type: "button",
                icon: "fa fa-eye",
                title: "View Conversation",
                visible: (model: any) => {
                    let customerPhoneNumber = '';
                    if (
                        model.customerPhoneNumber &&
                        model.customerPhoneNumber !== "0"
                    )
                        customerPhoneNumber = model.customerPhoneNumber;
                    return customerPhoneNumber && customerPhoneNumber !== "0";
                },
                action: (model: any) => {
                    this.setConversationValues(model);
                },
            },
            {
                type: "button",
                icon: "fa fa-clipboard",
                title: "View Follow Up Note",
                action: (model: any) => {
                    this.followUpNoteRepairOrderNumber = model.repairOrderNumber;
                    this.followUpNotePopup.model = true;
                    this.getFollowUpNotes();
                },
            },
        ];
    }

    public setConversationValues(model) {
        this.customerKey = model.customerKey;
        this.roNumber = model.repairOrderNumber;
        this.customerPhone = model.customerPhoneNumber;
        this.recordIdentifier = MetadataType[MetadataType.ROFollowUp].toString();
        this.conversationPopup.model = true;
        this.getExistingMessages();
    }

    public async getFollowUpRecords(): Promise<void> {

        try {
            this.loading = true;
            const response = await userService.PreCsiFollowUp(this.followUpPagination, this.followupDate, this.sentimentType, this.selectedAdvisorId);
             this.followupRecords = response.results || [];
             this.followUpPagination.totalItems = response.total || 0;

           if (!this.followupRecords.length) {
    this.showNotification( NotificationType.Warning,"No data found for selected date");
        }

        } finally {
            this.loading = false;
        }
    }
    public updatePaging(paging: any) {
        this.followUpPagination = paging;
        this.getFollowUpRecords();
    }

    public SearchFollowUp() {
        this.followUpPagination.page = 1;
        this.getFollowUpRecords();
        this.preCsiFollowSentimentCount();
    }

    public async preCsiFollowSentimentCount(): Promise<void> {

        try {
            this.percentageLoading = true;
            this.TotalCountPercentage = 0;
            this.negativeCountPercentage = "0";
            this.neutralCountPercentage = "0";
            this.positiveCountPercentage = "0";
            this.noRespondentCountPercentage = "0";

            const response = await userService.preCsiFollowSentimentCount(this.followupDate);
            if (response) {
                this.TotalCountPercentage = response.reduce((total, item) => total + item.sentimentCount, 0);
                if (this.TotalCountPercentage > 0) {
                    this.negativeCountPercentage = (response.filter(item => item.sentiment.toLowerCase() === 'negative').reduce((total, item) => total + item.sentimentCount, 0) / this.TotalCountPercentage * 100).toFixed(2);
                    this.neutralCountPercentage = (response.filter(item => item.sentiment.toLowerCase() === 'neutral').reduce((total, item) => total + item.sentimentCount, 0) / this.TotalCountPercentage * 100).toFixed(2);
                    this.positiveCountPercentage = (response.filter(item => item.sentiment.toLowerCase() === 'positive').reduce((total, item) => total + item.sentimentCount, 0) / this.TotalCountPercentage * 100).toFixed(2);
                    this.noRespondentCountPercentage = (response.filter(item => item.sentiment.toLowerCase() === '').reduce((total, item) => total + item.sentimentCount, 0) / this.TotalCountPercentage * 100).toFixed(2);
                }
            }
        } finally {
            this.percentageLoading = false;
        }
    }

    public async getAllAdvisors() {
        try {
            const advisors = await userService.getAllStoreAdvisors();
            this.allAdvisors = advisors;
        }
        finally {
        }
    }

    public async getExistingMessages(): Promise<void> {
        if (this.customerKey && this.recordIdentifier) {
            try {
                this.conversationLoading = true;
                const response = await messageService.getExistingMessages(
                    this.customerKey,
                    this.roNumber,
                    this.recordIdentifier
                );
                this.pagedTextLog = response.existingMessages.results;
                this.pagination.totalItems = response.existingMessages.results.length;
            } finally {
                this.conversationLoading = false;
                // this.customerKey = "";
                this.pagination.page = 1;
            }
        }
    }

    public conversationUpdatePaging(paging): void {
        this.pagination = paging;
    }

    public async getTemplates(): Promise<void> {
        try {
            this.formlyShowSkeleton(this.formFields, 'template');
            const response = await templateService.getStoreTemplates(TemplateAssociationType.Service);
            this.templates = response.results;
            this.setFieldSelectItems('template', this.templates);
        } finally {
            this.formlyHideSkeleton(this.formFields, 'template');
        }
    }

    public setFieldSelectItems(key, value): void {
        const field = this.formFields.find((m) => {
            return m.key === key;
        });
        if (field) {
            this.$set(field.templateOptions, 'items', value);
        }
    }

    public async sendMessage(): Promise<void> {
        try {
            this.disableSubmitButton = true;
            var response = await messageService.manualRoFollowUpReply(this.roNumber, this.customerPhone, this.messageToSend.body);
            if (response.success) {
                this.showAlert(true, "Message Sent Successfully!");
            }
        } finally {
            this.disableSubmitButton = false;
            this.messageToSend.body = "";
            this.messageToSend.template = "";
            this.getExistingMessages();
        }
    }
    public followUpNoteUpdatePaging(paging): void {
        this.pagination = paging;
    }


    public async sendNote() {
        if (!(await this.validateFormByScope('followUpNote'))) {
            return;
        }

        try {
            this.followUpStatusPopup.loading = true;
            await userService.postFolllowupNote(this.followUpNote, this.selectedRecord.repairOrderNumber, this.followupStatus);
            this.showAlert(true, "Follow up not added successfully");
        }
        finally {
            this.followUpStatusPopup.loading = false;
            this.followUpStatusPopup.model = false;
            this.followUpNote = "";
        }
    }


    public async getFollowUpNotes(): Promise<void> {

        try {
            this.followUpNoteLoading = true;
            const response = await userService.getFollowUpNotes(this.followUpNoteRepairOrderNumber);
            this.followUpNoteItems = response;
            this.followUpNotePagination.page = 1;
        } finally {
            this.followUpNoteLoading = false;
        }
    }

}
export default PreCsiFollowUpListPage;
